"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardStatus = exports.CardType = exports.InternalAccountType = exports.InternalAccountStatus = void 0;
var InternalAccountStatus;
(function (InternalAccountStatus) {
    InternalAccountStatus["Active"] = "Active";
    InternalAccountStatus["Inactive"] = "Inactive";
    InternalAccountStatus["Pending"] = "Pending";
})(InternalAccountStatus = exports.InternalAccountStatus || (exports.InternalAccountStatus = {}));
;
var InternalAccountType;
(function (InternalAccountType) {
    InternalAccountType["Clearing"] = "Clearing";
    InternalAccountType["TaxWithholding"] = "TaxWithholding";
    InternalAccountType["Banking"] = "Banking";
    InternalAccountType["InternationalClearing"] = "InternationalClearing";
    InternalAccountType["Deductions"] = "Deductions";
    InternalAccountType["Rewards"] = "Rewards";
    InternalAccountType["InternalOperations"] = "InternalOperations";
    InternalAccountType["Account"] = "Account";
})(InternalAccountType = exports.InternalAccountType || (exports.InternalAccountType = {}));
;
;
var CardType;
(function (CardType) {
    CardType["individualDebitCard"] = "individualDebitCard";
    CardType["businessDebitCard"] = "businessDebitCard";
    CardType["individualVirtualDebitCard"] = "individualVirtualDebitCard";
    CardType["businessVirtualDebitCard"] = "businessVirtualDebitCard";
})(CardType = exports.CardType || (exports.CardType = {}));
var CardStatus;
(function (CardStatus) {
    CardStatus["Active"] = "Active";
    CardStatus["Inactive"] = "Inactive";
    CardStatus["Stolen"] = "Stolen";
    CardStatus["Lost"] = "Lost";
    CardStatus["Frozen"] = "Frozen";
    CardStatus["ClosedByCustomer"] = "ClosedByCustomer";
    CardStatus["SuspectedFraud"] = "SuspectedFraud";
})(CardStatus = exports.CardStatus || (exports.CardStatus = {}));
//# sourceMappingURL=internalAccount.js.map